export const AGENCY_SETTINGS_PATHS = {
  DEFAULT: "/:regionId/agency-settings",
  BRANDING: "branding",
  FEATURE_PREFERENCES: "feature-preferences",
  VENDOR_EMAIL: "vendor-email",
} as const;
